export default function (src) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = resolve.bind(this, src);
        img.onerror = resolve.bind(this, false);
        img.src = src;
    });
}
